import { GroupItem } from '../../location-profile.model';

export const CONSTS = {
  ASSIGNED_GROUPS: $localize`Assigned Groups`,
  UNASSIGN: $localize`Unassign`,
  ALL_GROUPS: $localize`All Groups`,
  ASSIGN: $localize`Assign`,
};

export const ASSIGNED_GROUP_DATA: GroupItem[] = [
  { id: 'Group 1', selected: false, index: 1, code: 'Group1', name: 'Group 1' },
  { id: 'Group 2', selected: false, index: 2, code: 'Group1', name: 'Group 2' },
  { id: 'Group 3', selected: false, index: 3, code: 'Group1', name: 'Group 3' },
  { id: 'Group 4', selected: false, index: 4, code: 'Group1', name: 'Group 4' },
  { id: 'Group 5', selected: false, index: 5, code: 'Group1', name: 'Group 5' },
  { id: 'Group 6', selected: false, index: 6, code: 'Group1', name: 'Group 6' },
];

export const ALL_GROUP_DATA: GroupItem[] = [
  { id: 'Group 7', selected: false, index: 7, code: 'Group1', name: 'Group 7' },
  { id: 'Group 8', selected: false, index: 8, code: 'Group1', name: 'Group 8' },
  { id: 'Group 9', selected: false, index: 9, code: 'Group1', name: 'Group 9' },
  {
    id: 'Group 10',
    selected: false,
    index: 10,
    code: 'Group1',
    name: 'Group 10',
  },
  {
    id: 'Group 11',
    selected: false,
    index: 11,
    code: 'Group1',
    name: 'Group 11',
  },
  {
    id: 'Group 12',
    selected: false,
    index: 12,
    code: 'Group1',
    name: 'Group 12',
  },
  {
    id: 'Group 13',
    selected: false,
    index: 13,
    code: 'Group1',
    name: 'Group 13',
  },
  {
    id: 'Group 14',
    selected: false,
    index: 14,
    code: 'Group1',
    name: 'Group 14',
  },
  {
    id: 'Group 15',
    selected: false,
    index: 15,
    code: 'Group1',
    name: 'Group 15',
  },
  {
    id: 'Group 16',
    selected: false,
    index: 16,
    code: 'Group1',
    name: 'Group 16',
  },
  {
    id: 'Group 17',
    selected: false,
    index: 17,
    code: 'Group1',
    name: 'Group 17',
  },
  {
    id: 'Group 18',
    selected: false,
    index: 18,
    code: 'Group1',
    name: 'Group 18',
  },
  {
    id: 'Group 19',
    selected: false,
    index: 19,
    code: 'Group1',
    name: 'Group 19',
  },
  {
    id: 'Group 20',
    selected: false,
    index: 20,
    code: 'Group1',
    name: 'Group 20',
  },
  {
    id: 'Group 21',
    selected: false,
    index: 21,
    code: 'Group1',
    name: 'Group 21',
  },
  {
    id: 'Group 22',
    selected: false,
    index: 22,
    code: 'Group1',
    name: 'Group 22',
  },
  {
    id: 'Group 23',
    selected: false,
    index: 23,
    code: 'Group1',
    name: 'Group 23',
  },
  {
    id: 'Group 24',
    selected: false,
    index: 24,
    code: 'Group1',
    name: 'Group 24',
  },
  {
    id: 'Group 25',
    selected: false,
    index: 25,
    code: 'Group1',
    name: 'Group 25',
  },
];
